module.exports = __webpack_public_path__ + "img/default.edcae8dc.jpg";